import { activationRoutes } from './lib/activation.routes';
export default activationRoutes;
